module.exports = __webpack_public_path__ + "static/herobg-06-min-47300b9bacce6954be9fe067ccc2288e.jpg";